import './utils/jqueryLoader.js'
import React, { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import ReactGA from "react-ga4";
import ReactPixel from 'react-facebook-pixel';

const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
};
//Anterior
//ReactPixel.init('864551054974472', options);
// Nueva
ReactPixel.init('364011971871528', options);

//Anterior Google Analitics Tag 09/10/2023, Actuliza Marco. 
//ReactGA.initialize("G-D1G6CRGXPH");
// ReactGA.initialize("GTM-M3T6M4S");
//
// ReactGA.initialize([
//     {
//         trackingId: "GTM-K5PNLWC3",
//         gaOptions: {
//             'debug_mode':false
//         }, // optional
//         gtagOptions: {
//             'debug_mode':false
//         }, // optional
//     }
// ]);

// --- TikTok Pixel Loader e Inicialización ---
function initTikTokPixel(pixelId) {
    if (typeof window === 'undefined') return;
    if (window.__ttqLoaded) return;

    (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = [
            "page","track","identify","instances","debug","on","off","once","ready",
            "alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"
        ];
        ttq.setAndDefer = function(obj, method){
            obj[method] = function(){
                obj.push([method].concat(Array.prototype.slice.call(arguments,0)))
            }
        };
        for (var i = 0; i < ttq.methods.length; i++) {
            ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function(id){
            var inst = ttq._i[id] || [];
            for (var i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(inst, ttq.methods[i]);
            }
            return inst;
        };
        ttq.load = function(e, n){
            var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = r + "?sdkid=" + e + "&lib=" + t;
            var firstScript = d.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(s, firstScript);
            ttq._i = ttq._i || {};
            ttq._i[e] = [];
            ttq._i[e]._u = r;
            ttq._t = ttq._t || {};
            ttq._t[e] = +new Date();
            ttq._o = ttq._o || {};
            ttq._o[e] = n || {};
        };
    })(window, document, 'ttq');

    // Carga del pixel
    window.ttq.load(pixelId);
    window.__ttqLoaded = true;
}


// --- LinkedIn Pixel Loader e Inicialización ---
function initLinkedInPixel(partnerId) {
    if (typeof window === 'undefined') return; // SSR guard
    if (window.__lintrkLoaded) return; // idempotency

    // Configuración de partner IDs
    window._linkedin_partner_id = partnerId;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    if (window._linkedin_data_partner_ids.indexOf(partnerId) === -1) {
        window._linkedin_data_partner_ids.push(partnerId);
    }

    // Stub de lintrk con cola (similar a ttq)
    (function(l){
        if (!l) {
            window.lintrk = function(a, b) {
                window.lintrk.q = window.lintrk.q || [];
                window.lintrk.q.push([a, b]);
            };
            window.lintrk.q = window.lintrk.q || [];
        }
        var firstScript = document.getElementsByTagName('script')[0];
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(s, firstScript);
        } else {
            document.head ? document.head.appendChild(s) : document.body && document.body.appendChild(s);
        }
    })(window.lintrk);

    window.__lintrkLoaded = true;
}

// --- Google Tag Manager Loader e Inicialización ---
function initGTM(gtmId) {
    if (typeof window === 'undefined') return;
    if (window.__gtmLoaded) return;
    
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',gtmId);

    window.__gtmLoaded = true;
}

// Inicializar TikTok Pixel antes del render
initTikTokPixel('CMG7H33C77UFIL1R7S60');

// Inicializar LinkedIn Pixel antes del render
initLinkedInPixel('8753106');

// Inicializar Google Tag Manager
initGTM('GTM-TCDWRCZB');

// Si arrancamos o refrescamos en /sign-up, enviar un page() para anclar la sesión antes del track del componente
if (typeof window !== 'undefined' && window.ttq && window.location?.pathname === '/sign-up') {
    try { window.ttq.page(); } catch (e) {}
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
);